import styled from 'styled-components';

export const WaterTank = styled.div`
  background: white;
  min-height: 100%;
`
